module.exports = __webpack_public_path__ + "media/images/icon-home-off@3x-726df7c2c79d5844448f241b01052c9a.png";